// 📄 components/StepHesBadis.tsx
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { HesFormData } from '../../../../../services/commerce/integrationService';

interface StepHesBadisProps {
  badiSesCreateActive: boolean;
  badiSesDeleteActive: boolean;
  onChange: (field: keyof HesFormData, value: any) => void;
}

export function StepHesBadis({ badiSesCreateActive, badiSesDeleteActive, onChange }: StepHesBadisProps) {
  return (
    <div className="space-y-4 animate-fadeIn">
      <div className="bg-blue-500/5 border border-blue-500/10 rounded-xl p-3 mb-2 space-y-1">
        <span className="text-[10px] font-bold text-blue-400 uppercase tracking-widest block">Ruta SPRO / Transacción SAP</span>
        <p className="font-mono text-xs text-gray-300">
          <span className="bg-zinc-800 px-1.5 py-0.5 rounded text-gray-400 font-bold mr-1.5">SE18 / SE19</span>
          <span>SAP Menu → Tools → ABAP Workbench → Utilities → Business Add-Ins → Implementation</span>
        </p>
      </div>

      <div>
        <h3 className="text-lg font-medium text-blue-400">2. Implement BAdIs / Exits</h3>
        <p className="text-sm text-gray-400">
          Implementa los BAdIs que permiten personalizar la creación y la cancelación (eliminación) de la Hoja de Entrada de Servicios.
        </p>
      </div>

      <div className="bg-white/5 p-4 rounded-xl border border-white/5 space-y-4">
        <div className="flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">BAdI <code className="bg-black/30 px-1 rounded font-mono text-blue-400">ARBCIG_SES_CREATE</code></label>
            <p className="text-xs text-gray-400 mt-0.5">Personalización de la creación de la HES</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input type="checkbox" checked={badiSesCreateActive || false} onChange={(e) => onChange('badiSesCreateActive', e.target.checked)} className="sr-only peer" />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>

        <div className="border-t border-white/5 pt-3 flex items-center justify-between gap-4">
          <div>
            <label className="block text-sm font-medium text-white">BAdI <code className="bg-black/30 px-1 rounded font-mono text-blue-400">ARBCIG_SES_DELETE</code></label>
            <p className="text-xs text-gray-400 mt-0.5">Cancelación / eliminación de la HES</p>
          </div>
          <label className="relative inline-flex items-center cursor-pointer flex-shrink-0">
            <input type="checkbox" checked={badiSesDeleteActive || false} onChange={(e) => onChange('badiSesDeleteActive', e.target.checked)} className="sr-only peer" />
            <div className="w-9 h-5 bg-zinc-700 rounded-full peer peer-checked:after:translate-x-full peer-checked:bg-blue-500 after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all"></div>
          </label>
        </div>
      </div>

      <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-xl p-4 text-yellow-400 flex gap-3 text-sm">
        <AlertTriangle className="w-5 h-5 flex-shrink-0" />
        <div>
          <p className="font-semibold">Lógica custom del cliente</p>
          <p className="text-xs text-yellow-500/80 mt-0.5">
            El código de la implementación del BAdI es responsabilidad del equipo ABAP — documenta el detalle en la sección de Personalizaciones / Desarrollos Z de este paso.
          </p>
        </div>
      </div>
    </div>
  );
}
